export const MODAL_WIDTH = 550
export const OFFSET_ICON = 4
